import React from 'react';

export const CrossSvg = ({size = "", color = ""}) => (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" fill={color} width={size} height={size} viewBox="0 0 612 612">
    <g id="cross">
      <polygon points="612,36.004 576.521,0.603 306,270.608 35.478,0.603 0,36.004 270.522,306.011 0,575.997 35.478,611.397 306,341.411 576.521,611.397 612,575.997 341.459,306.011" />
    </g>
  </svg>
);
